// Test-mode banner disabled now that Razorpay (IN) and Paddle (intl) are live.
export function PaymentTestModeBanner() {
  return null;
}
